var t = "function",
    n = "string",
    e = "undefined",
    r = "boolean",
    o = "object",
    u = "array",
    i = "number",
    f = function f() {},
    c = "undefined" != typeof window;

function p(t) {
  return "function" == typeof t;
}

function a(t) {
  return "string" == typeof t;
}

function l(t) {
  return "number" == typeof t && !isNaN(t);
}

function y(t) {
  return void 0 === t;
}

function d(t) {
  return "boolean" == typeof t;
}

function s(t) {
  return null === t;
}

function b(t) {
  return "[object Array]" === Object.prototype.toString.call(t);
}

function g(t) {
  if ("object" != typeof t || null === t) return !1;

  for (var n = t; null !== Object.getPrototypeOf(n);) {
    n = Object.getPrototypeOf(n);
  }

  return Object.getPrototypeOf(t) === n;
}

function m(t) {
  return t instanceof RegExp;
}

function O(t) {
  if (!p(t)) return !1;
  var n = /{(\r|\n|\s)*}/gm,
      e = f.toString();
  return e === (t.toString().match(n) || [""])[0].replace(n, e);
}

function j(t) {
  return !(a(t) && "false" === t.toLowerCase() || !t);
}

function v(t) {
  return NodeList.prototype.isPrototypeOf(t);
}

function S(t) {
  return t instanceof Element || t instanceof HTMLDocument;
}

function N(t) {
  return S(t) && "FORM" === t.nodeName;
}

function P(t, n) {
  if (!t || "hidden" === getComputedStyle(t).visibility) return !0;

  for (; t;) {
    if (null != n && t === n) return !1;
    if ("none" === getComputedStyle(t).display) return !0;
    t = t.parentElement;
  }

  return !1;
}

export { u as ARRAY, r as BOOLEAN, t as FUNCTION, i as NUMBER, o as OBJECT, n as STRING, e as UNDEFINED, b as isArray, d as isBoolean, c as isBrowser, S as isElement, N as isForm, p as isFunction, P as isHidden, O as isNoOp, v as isNodeList, s as isNull, l as isNumber, g as isObject, m as isRegex, a as isString, j as isTruthy, y as isUndefined, f as noOp };